import {  AfterViewChecked, AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TiposConfiguracion } from 'src/environments/Configuration/TiposConfiguracion';
import { environment } from 'src/environments/environment';
import { Firmantes } from '../../models/firmantes';
import { TipoBusqueda } from '../../models/tipo-busqueda';
import { TipoDestinatario } from '../../models/tipo-destinatario';
import { TipoFirmante } from '../../models/tipo-firmante';
import { DatosEnviosService } from '../../services/datos-envios.service';
import { FormularioEnvioService } from '../../services/formulario-envio.service';
import { FormularioValidacionesService } from '../../services/formulario-validaciones.service';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';

@Component({
  selector: 'app-detalle-firmantes',
  templateUrl: './detalle-firmantes.component.html',
  styleUrls: ['./detalle-firmantes.component.css']
})
export class DetalleFirmantesComponent implements OnInit{

  @Input() firmante: Firmantes;
  @Input() inputOtro: boolean;
  @Input() i: number;
  @Input() destinatarios: TipoDestinatario[] = [];
  @Input() busquedas: TipoBusqueda[] = [];
  descDestinatario: string = '';
  descBusqueda: string = '';
  firmanteForm: FormGroup = new FormGroup({});
  firmantePrincipalCodigo: string = '100';
  mostrarFirmantePpal: boolean = true;
  destinatarioFirmanteCodigo: string ='';

  destinatariosDropdown: DesplegableData[] = [];
  firmanteDestinatario: DesplegableData;
  busquedasDropdown: DesplegableData[] = [];
  destinatarioPreSeleccionado: DesplegableData;
  busquedaPreSeleccionado: DesplegableData;

  @Output() eliminarClicked: EventEmitter<any> = new EventEmitter<any>();
  @Input() resetBusqueda: boolean;

  constructor(private fb: FormBuilder,
              public formularioEnvioService: FormularioEnvioService,
              public formularioValidacionesService: FormularioValidacionesService,
              public conversionDatosApiService: ConversionDatosApiService) {
              }

  ngOnChanges(changes: SimpleChanges){
    if(changes.resetBusqueda?.currentValue){
      this.busqueda.setValue("");
    }
    if(changes.destinatarios?.currentValue){
      this.destinatariosDropdown = this.conversionDatosApiService.mapCodigoAIdEntrada(changes.destinatarios.currentValue);
    }
    if(changes.busquedas?.currentValue){
      this.busquedasDropdown = this.conversionDatosApiService.mapCodigoAIdEntrada(changes.busquedas.currentValue);
    }
    if(changes.firmante?.currentValue){
      const nuevoDestinatarioId = this.firmante.tipoDestinatario.codigo;
      const nuevaBusquedaId = this.firmante.tipoBusqueda.codigo;

      if(!this.destinatarioPreSeleccionado || this.destinatarioPreSeleccionado.id !== nuevoDestinatarioId){
        this.destinatarioPreSeleccionado = {
          id: nuevoDestinatarioId,
          desc: this.firmante.tipoDestinatario.desc
        };
      }

      if(!this.busquedaPreSeleccionado || this.busquedaPreSeleccionado.id !== nuevaBusquedaId){
        this.busquedaPreSeleccionado = {
          id: nuevaBusquedaId,
          desc: this.firmante.tipoBusqueda.desc
        };
      }
    }

  }

  ngOnInit(): void {
    this.inicializaFormulario();
    if(environment.Configuracion == TiposConfiguracion.V3) this.destinatarioFirmanteCodigo = 'signer';
    else this.destinatarioFirmanteCodigo = '201';

    // Initialize firmante destinatario
    this.firmanteDestinatario = {
      id: this.destinatarioFirmanteCodigo,
      desc: 'Firmante'
    };

  }

  get esRLT(){ return this.formularioEnvioService.formularioEnvio.controls['esRLT']}

  inicializaFormulario(){
    let valorTipoFirmante = this.firmante.tipoFirmante.desc;

    if(this.firmante.tipoFirmante.codigo !== '100'){
      this.mostrarFirmantePpal = false;
    }
    this.firmanteForm = this.fb.group({
      tipoFirmanteInput: [valorTipoFirmante, Validators.required],
      destinatario:[this.firmante.tipoDestinatario.codigo, Validators.required],
      busqueda: [this.firmante.tipoBusqueda.codigo, Validators.required]
    })
  }


  get destinatario(){
    return this.firmanteForm.get('destinatario')
  }

  get busqueda(){
    return this.firmanteForm.get('busqueda')
  }

  get tipoFirmanteInput(){
    return this.firmanteForm.get('tipoFirmanteInput')
  }

  cambioLista(){
    this.buscaDescripciones();
    let firmanteActualizado: Firmantes = {
      orden: this.firmante.orden,
      tipoFirmante:{
        codigo: this.firmante.tipoFirmante.codigo, desc: this.tipoFirmanteInput?.value},
      tipoDestinatario:{
        codigo: this.destinatario?.value, desc: this.descDestinatario },
      tipoBusqueda:{
        codigo: this.busqueda?.value, desc: this.descBusqueda}
      }
      this.formularioEnvioService.updateFirmantes(firmanteActualizado)
  }

  buscaDescripciones(){
    this.destinatarios?.forEach(x => {
      if(x.codigo == this.destinatario?.value){
        this.descDestinatario = x.desc
      }
    })
    this.busquedas?.find(x => {
      if(x.codigo == this.busqueda?.value){
        this.descBusqueda = x.desc
      }
    })
  }

  clicked(){
    this.eliminarClicked.emit(this.firmante.orden)
  }

  onDestinatarioSeleccionado(destinatario: any){
    if(!destinatario?.id){
      return;
    }
    // Check if the field is disabled due to esRLT
    if(this.esRLT.value) {
      return; // Don't allow changes when disabled
    }
    if(this.destinatario?.value === destinatario.id){
      return;
    }
    this.destinatario?.setValue(destinatario.id);
    this.cambioLista();
  }

  onBusquedaSeleccionada(busqueda: any){
    if(!busqueda?.id){
      return;
    }
    // Check if the field is disabled due to esRLT
    if(this.esRLT.value) {
      return; // Don't allow changes when disabled
    }
    if(this.busqueda?.value === busqueda.id){
      return;
    }

    this.busqueda?.setValue(busqueda.id);
    this.cambioLista();
  }

}
